import Loading from '../Loading';
import styles from './index.less';

interface Props {
    tip?: string;
}

export default ({tip}: Props) => (
    <div className={styles.suspenseFallback}><Loading tip={tip} /></div>
);
